<template>
  <!-- 用户协议 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>用户协议</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <p class="title">用户协议</p>
            <div>
              欢迎注册成为第一财经杂志App及官网用户，注册前请阅读以下条款：
            </div>
            <div>
              第一财经杂志App及官网（以下简称“本网”）。依据本服务条款协议（以下简称“本协议”）所列条款，第一财经官网为您开放网站、平台及服务
              (统称为“平台”)。本协议适用于本平台所有用户。
            </div>
            <div>
              <strong>一、本网服务条款的确认和接纳：</strong>
              <p>
                本网各项电子服务的所有权和运作权归上海第一财经传媒有限公司。本网提供的服务将完全按照其发布的章程、服务条款和操作规则严格执行。用户必须完全同意所有服务条款并完成注册程序，才能成为本网的正式用户。
              </p>
            </div>
            <div>
              <strong>二、服务简介：</strong>
              <p>
                本网运用自己的操作系统，通过国际互联网络为用户提供网络服务。同时，用户必须：
              </p>
              <p>
                1、自行配备上网所需设备，包括个人电脑、调制解调器或其他必备上网装置。
              </p>
              <p>
                2、自行负担个人上网所支付的与此服务有关的电话费用、网络费用。
              </p>
              <p>基于本网所提供的网络服务的重要性，用户应同意：</p>
              <p>1、提供详尽、准确的个人资料。</p>
              <p>2、不断更新注册资料，符合及时、详尽、准确的要求。</p>
              <p>
                本网不公开用户的姓名、地址、电子邮箱和笔名，但以下情况例外：
              </p>
              <p>1、用户授权本网透露这些信息。</p>
              <p>
                2、相应的法律及程序要求本网提供用户的个人资料。如果用户提供的资料包含有不正确的信息，本网保留结束用户使用网络服务资格的权利。
              </p>
            </div>
            <div>
              <strong>三、服务条款的修改和终止：</strong>
              <p>
                您同意我们可单方面的给予警告，暂时停止、无限期终止、删除您张贴的内容或信息，或可终止您的会员身份，或可解除您使用本平台全部或任何部分服务的能力。您同意根据本协议任何条款可终止您的账号或您对本平台全部或任何部分访问权。从即日起本网建议您定期上网查看最新的条款规定，未来任何条款如有更新我们将不再另行通知，条款自修改之日起立即生效。并且同意我们可立即冻结或删除您的账号及账号内的相关信息与文件，或禁止对此类文件或本平台的进一步访问。您也同意针对终止您对本平台的使用或对全部或任何部分的访问权的行为，我们对您或任何第三方不承担任何责任。
              </p>
            </div>
            <div>
              <strong>四、用户隐私制度：</strong>
              <p>
                尊重用户个人隐私是本网的一项基本政策。本网不会在未经合法用户授权时公开、编辑或透露其注册资料及其它保存在本网中的非公开内容，但不包括以下四种必要情况：
              </p>
              <p>1、遵守有关法律规定，遵从本网合法服务程序。</p>
              <p>2、维护本网的商标所有权。</p>
              <p>3、在紧急情况下竭力维护用户个人和社会大众的隐私安全。</p>
              <p>4、符合其他相关的要求。</p>
            </div>
            <div>
              <strong>五、用户的帐号，密码和安全性：</strong>
              <p>
                用户一旦注册成功，成为本网的合法用户，将得到一个密码和用户名。用户将对用户名和密码安全负全部责任。另外，每个用户都要对以其用户名进行的所有活动和事件负全责。用户若发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通告本网。
              </p>
            </div>
            <div>
              <strong>六、用户管理：</strong>
              <p>
                用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于本网的国家法律、地方法律和国际法律标准的。用户必须遵循：
              </p>
              <p>1、从中国境内向外传输技术性资料时必须符合中国有关法规。</p>
              <p>2、使用网络服务不作非法用途。</p>
              <p>3、不干扰或混乱网络服务。</p>
              <p>4、遵守所有使用网络服务的网络协议、规定、程序和惯例。</p>
              <p>用户须承诺不得违反宪法确定的基本原则：</p>
              <p>
                1）不得危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一；
              </p>
              <p>2）不得损害国家荣誉和利益；</p>
              <p>3）不得煽动民族仇恨、民族歧视、破坏民族团结；</p>
              <p>4）不得破坏国家宗教政策，宣扬邪教和封建迷信；</p>
              <p>5）不得散布谣言、扰乱社会秩序、破坏社会稳定；</p>
              <p>
                6）不得散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪。请注意使用文明用语，请勿张贴对任何人进行人身攻击、谩骂、诋毁的言论；
              </p>
              <p>7）不得侮辱或者诽谤他人，侵害他人合法权益；</p>
              <p>8）不得煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
              <p>9）不得以非法民间组织名义活动；</p>
              <p>10）不得含有法律、行政法规禁止的其他内容；</p>
              <p>
                11）不得发布可能会妨害第三方权益的文件或者信息，例如（包括但不限于）：病毒代码、黑客程序、软件破解注册信息；
              </p>
              <p>
                12）不得抄袭及剽窃他人作品，禁止转载或引用涉及版权问题的文章；
              </p>
              <p>13）未经本网允许，不得发表任何形式的广告；</p>
              <p>
                14）不得发表与本网宗旨无关的文章评论、上传与内容无关图片，禁止一帖多发、刷贴等恶意灌水现象；
              </p>
              <p>15）不得发表破坏本网公共秩序及侵害本网利益的其他内容；</p>
              <p>16）不得直接或间接链接到您无权链接或包含的任何资料。</p>
              <p>
                此外，您应当在注册时或邮箱更改时提供您当前使用的有效邮箱地址。您需同意您所提交的会员资料、评论、上传的照片或网站内其它内容，不得用于商业活动、商品或服务买卖、商品或服务推销等用途。不论是否有意为之，您在本网公开区域所透露的任何信息，您本人应负全部责任。若您的行为不符合以上提到的服务条款，本网将作出独立判断立即取消您服务帐号的使用，您需对自己在网上行为承担法律责任。如您在本网上散布和传播反动、色情或其他违反国家法律的信息，本网的系统记录有可能作为用户违反法律的证据。
              </p>
            </div>
            <div>
              <strong>七、责任声明</strong>
              <p>
                1、
                用户之间通过本网相识、交往中所发生或可能发生的任何心理、生理上的伤害和经济上的损失，本网不承担任何责任。
              </p>
              <p>
                2、
                用户如因资料保管不妥或其他原因而导致个人隐私被他人泄露的，本网不承担任何责任。
              </p>
              <p>
                3、
                用户因为违反本网规定而触犯中华人民共和国法律的，责任自负，本网不承担任何责任。
              </p>
              <p>
                4、
                由于非故意及不可抗拒的原因（含系统维护和升级），导致用户数据丢失、服务暂停或停止，本网不承担赔偿及其他连带的法律责任。
              </p>
            </div>
            <div>
              <strong>八、网络服务内容的所有权：</strong>
              <p>
                本网定义的网络服务内容包括：文字、软件、声音、图片、录像、图表、广告中的全部内容；电子邮件的全部内容；本网为用户提供的其他信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在本网和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。本网所载第一财经电视、第一财经频率以及第一财经日报的内容版权归第一财经所有，本网拥有转授授权，任何人需要转载本网的文章，必须征得本网同意授权。
              </p>
            </div>
            <div>
              <strong>九、不得转售：</strong>
              <p>
                您同意不仿造、复制、拷贝、出售、转售第一财经杂志的相关商品，或将其作商用目的，不得使用或利用任何第三方平台（如淘宝、微信等其他平台）出售任何商品或服务，也不得将本网提供的产品用于任何形式的公司、商品或服务的促销行为。一经发现转售，本网将有权利终止为您提供服务并封禁相关账户。
              </p>
            </div>
            <div>
              <strong>十、与营销合作伙伴及第三方的交易：</strong>
              <p>
                您在本平台或通过本平台进行的与营销合作伙伴及其他第三方的通信、商业交易、或对其促销活动的参与，包括相关产品或服务的付款和交付，以及与此类交易相关的任何条款、条件、担保或代表，仅仅是您与此类营销合作伙伴或其他第三方之间的事宜。因此类交易造成的或在本网站或通过使用本网站而链接到的此类营销伙伴或其他第三方的存在造成的任何损失或破坏，您同意第一财经周刊不承担任何责任或义务。
              </p>
            </div>
            <div>
              <strong>十一、免责条款：</strong>
              <p>
                本网对因卫星传输线路、电信部门及网络服务提供商等任何原因造成的信息传递异常情况所至后果不承担法律责任，但有义务积极协助电信部门、网络服务提供商使之恢复正常。用户应始终避免并消除由于上述原因造成的信息遗漏、错误、丢失、延迟、中断等可能给第一财经带来不利影响的因素，使其免受经济损失和名誉损失，不得因本合同关系而以上述缘由向本网提出索赔。此外，由于地震、台风、战争、罢工、政府行为、瘟疫、爆发性和流行性传染病或其他重大疫情、非因各方原因造成的火灾、基础电信网络中断造成的及其它各方不能预见并且对其发生后果不能预防或避免的不可抗力原因，致使相关服务中断，本网不承担由此产生的损失，但应及时通知服务中断原因，并积极加以解决。
              </p>
            </div>
            <div>
              <strong>十二、解释权</strong>
              <p>
                您在注册过程中表明您已阅读并同意本协议，说明您同意您已阅读本协议并表示同意明白本协议的所有条款。
              </p>
            </div>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {};
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  text-align: justify;
  .title {
    font-weight: bold;
  }
  p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  div {
    font-size: 18px;
    line-height: 36px;
    margin-bottom: 40px;
  }
  div:last-child {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footer/agreement.vue